import enCommon from '@/locales/en/common.json';
import enGuideProfile from '@/locales/en/guideProfile.json';
import enRewards from '@/locales/en/rewards.json';
import hiCommon from '@/locales/hi/common.json';
import hiGuideProfile from '@/locales/hi/guideProfile.json';
import hiRewards from '@/locales/hi/rewards.json';

/** Languages offered in the switcher, each named in its own script. */
export const SUPPORTED_LANGUAGES = [
  { code: 'en', nativeName: 'English' },
  { code: 'hi', nativeName: 'हिंदी' },
] as const;

export const DEFAULT_LANGUAGE = 'en';

/** Remembers the visitor's choice between visits. */
export const LANGUAGE_STORAGE_KEY = 'preferred_language';

/** One namespace per feature, plus `common` for text shared across features. */
export const resources = {
  en: { common: enCommon, guideProfile: enGuideProfile, rewards: enRewards },
  hi: { common: hiCommon, guideProfile: hiGuideProfile, rewards: hiRewards },
} as const;
